import { render, staticRenderFns } from "./TutorBreakCard.vue?vue&type=template&id=ba0e5baa&scoped=true&"
import script from "./TutorBreakCard.vue?vue&type=script&lang=js&"
export * from "./TutorBreakCard.vue?vue&type=script&lang=js&"
import style0 from "./TutorBreakCard.vue?vue&type=style&index=0&id=ba0e5baa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba0e5baa",
  null
  
)

export default component.exports